import { render, staticRenderFns } from "./dates.vue?vue&type=template&id=620aa0b8&scoped=true&lang=pug&"
import script from "./dates.vue?vue&type=script&lang=js&"
export * from "./dates.vue?vue&type=script&lang=js&"
import style0 from "./dates.vue?vue&type=style&index=0&id=620aa0b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620aa0b8",
  null
  
)

export default component.exports